import { topicGroups } from "@/mocks/siteData";
import SectionHeader from "./SectionHeader";

export default function TopicSection() {
  return (
    <section id="topics" className="relative scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="话题分类"
          title="栏目一栏打尽"
          desc="按内容类型划分的清晰栏目，点击即可定位到对应专区，快速找到你最关心的一类话题与相关资讯。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {topicGroups.map((g) => (
            <article
              key={g.key}
              className="group flex flex-col sm:flex-row overflow-hidden rounded-2xl border border-background-200 bg-background-50 hover:border-primary-200 hover:shadow-sm transition-all"
            >
              <div className="relative sm:w-52 lg:w-56 shrink-0 overflow-hidden">
                <img
                  src={g.image}
                  alt={`${g.name}栏目封面`}
                  title={`${g.name}栏目`}
                  className="w-full h-44 sm:h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center justify-center w-9 h-9 rounded-lg bg-background-50/90 text-primary-600 backdrop-blur">
                  <i className={`${g.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="flex items-center gap-2 font-heading font-bold text-lg text-foreground-950">
                  {g.name}
                  <span className="text-xs font-normal text-foreground-400">#{g.key}</span>
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{g.desc}</p>
                <ul className="mt-3 flex flex-wrap gap-2">
                  {g.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#latest"
                        className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {item}
                        <i className="ri-arrow-right-up-line text-xs w-3 h-3 flex items-center justify-center"></i>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}